module.exports = __webpack_public_path__ + "img/delete-icon.8f4de623.svg";